var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"badge product-badge",style:(_vm.badgeStyle),attrs:{"title":_vm.productName}},[_vm._v(" "+_vm._s(_vm.productName)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }